
import React, { useState } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import question from "../../assets/question.png"
import { MdArrowRight } from "react-icons/md";



const TestQuestion = ({questionData}) => {
      const [openIndex, setOpenIndex] = useState(null); 
    
      const toggleVisibility = (id) => {
        setOpenIndex(openIndex === id ? null : id); 
      };
  return (
      <div className="w-full  flex flex-col justify-center items-center py-[4rem]">
          <h2 className="sm:text-5xl text-3xl font-bold text-white text-center  px-4 lg:px-0">
            প্রয়োজনীয় প্রশ্ন এবং উত্তর
          </h2>
          <div className="xl:w-[1296px] w-full flex lg:flex-row flex-col gap-4 lg:mt-[4rem] mt-[2rem]">
            <div className="lg:w-1/2 w-full flex flex-col gap-1">
              {questionData.map((item) => (
                <div key={item.id} className="w-full flex flex-col gap-2 p-1">
                  <div className={`flex justify-between items-center rounded-md p-3 cursor-pointer ${openIndex === item.id && "border-2 border-[#043B55] "}`} onClick={() => toggleVisibility(item.id)} >
    
                    <h2 className={`text-xl font-semibold  ${openIndex === item.id ? "text-[#22BEFF]":"text-gray-400 "}`}>
                      {item.header}
                    </h2>
    
                    <span className="text-xl text-[#22BEFF]">
                      {openIndex === item.id ? <FaAngleUp /> : <FaAngleDown />}
                    </span>
                  </div>
    
                  {/* Only show <p> tag if this item is open */}
                  {openIndex === item.id && (
                    item?.text.map((textValue,index)=>(
                        <div key={index} className="flex flex-col gap-4">
                        <p className=" font-normal text-xl text-gray-400  pl-2 flex  gap-1"><MdArrowRight className="text-2xl"/>{textValue}</p>
                    </div>
                    ))
                    
                    
                  )}
                </div>
              ))}
            </div>
            <div className="lg:w-1/2 w-full">
              
              <img src={question} alt="hfhfh" />
            
            </div>
          </div>
        </div>
  )
}

export default TestQuestion